<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="employees.employeeID > 0 ? '编辑员工':'新建员工'"
      class="customer-edit"
      width="800px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="employees"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="基本信息" name="first">
          <el-row>
            <el-col :span="12">
              <el-form-item label="编号">
                <el-input v-model="employees.employeeNO" disabled placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="姓名" prop="employeeName">
                <el-input v-model="employees.employeeName" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="性别">
                <el-radio-group v-model="employees.gender">
                  <el-radio :label="0">男</el-radio>
                  <el-radio :label="1">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="外部编号">
                <el-input v-model="employees.outerNo" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="部门" prop="departmentName">
                <div style="display: flex;flex-direction: row;">
                  <el-input v-model="employees.departmentName" placeholder="请输入" readonly>
                    <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectDepartment.open()">选择部门</el-button>
                  </el-input>
                  <department-select ref="selectDepartment" @select="selectDepartment"/>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职位" prop="postName">
                <el-select v-model="employees.postName" clearable placeholder="请选择">
                  <el-option
                      v-for="item in positionList"
                      :key="item.postID"
                      :label="item.postName"
                      :value="item.postName"
                      @click.native="selectParentName(item.postID)"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="生日">
                <el-date-picker
                    v-model="employees.birthday"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电子邮箱">
                <el-input v-model="employees.email" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="电话">
                <el-input v-model="employees.telephone" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机">
                <el-input v-model="employees.mobile" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="邮编">
                <el-input v-model="employees.postCode" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item/>
            </el-col>
          </el-row>
          <el-form-item label="住址">
            <el-input v-model="employees.address" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="employees.note" placeholder="请输入"/>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="SAP采购组" name="second">
          <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectPurchaseGroup.open()">
            新增
          </el-button>
          <el-table :data="employees.extPurchaseGroups">
            <el-table-column prop="extPurchaseGroupName" align="center" label="名称"/>
            <el-table-column prop="extPurchaseGroupNo" align="center" label="编号"/>
            <el-table-column label="操作" align="center" width="120px">
              <template slot-scope="scope">
                <el-button type="danger" @click="oneDeletePurchaseGroup(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <purchase-group-select ref="selectPurchaseGroup" @select="addPurchaseGroup"/>
        </el-tab-pane>
        <el-tab-pane label="物料组" name="three">
          <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectMaterialGroup.open()">
            新增
          </el-button>
          <el-table :data="employees.materialGroups">
            <el-table-column prop="materialNo" align="center" label="编号"/>
            <el-table-column prop="materialName" align="center" label="名称"/>
            <el-table-column label="操作" align="center" width="120px">
              <template slot-scope="scope">
                <el-button type="danger" @click="oneDeleteMaterialGroup(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <material-group-select ref="selectMaterialGroup" @select="addMaterialGroup"/>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import constants from "../../../util/constants";
  import regular from "@/util/regular";
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";
  import PurchaseGroupSelect from "@/views/information/Employee/PurchaseGroupSelect";
  import MaterialGroupSelect from "@/views/information/Employee/MaterialGroupSelect";

  export default {
    name:"EmployeeEdit",
    components: {MaterialGroupSelect, PurchaseGroupSelect, DepartmentSelect},
    data() {
      return {
        constants,
        activeName: "first",
        positionList:[],
        departmentList:[],
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        employees: {
          employeeID: 0,
          employeeNO: "",
          outerNo: "",
          employeeName: "",
          gender: 0,
          departmentID: "",
          departmentName: "",
          postID: "",
          postName: "",
          birthday: "",
          telephone: "",
          mobile: "",
          address: "",
          email: "",
          postCode: "",
          note: "",
          extPurchaseGroups: [],
          materialGroups: [],
        },
        ruleValidate: {
          employeeName: {required: true, message: "不能为空",trigger: "blur"},
          departmentName: {required: true, message: "不能为空",trigger: "blur"},
          // mobile:
          //   {
          //     required: true,
          //     pattern: regular.phone,
          //     message: "手机号格式不对",
          //     trigger: "blur",
          //   },
          postName: {required: true, message: "不能为空",trigger: "blur"},
        },
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          shortcuts: [{
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          }, {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          }, {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          }],
        },
      };
    },
    methods: {
      open(id) {
        this.employees.employeeID = id;
        console.log(this.employees.employeeID);
        this.dialogVisible = true;
        this.getPositionList();
        this.getDepartmentList();
        if(id>0) {
          this.getData();
        }else {
          this.getNode();
        }
      },
      getPositionList() {
        this.$http
          .get("basic", "posts/list")
          .then(resp => {
            this.positionList = resp;
          });
      },
      getDepartmentList() {
        this.$http
          .get("basic", "departments/list")
          .then(resp => {
            console.log(resp);
            this.departmentList = resp;
          });
      },
      addPurchaseGroup(row) {
        let flag = false;
        for (let item of this.employees.extPurchaseGroups) {
          if (item.extPurchaseGroupName === row.name && item.extPurchaseGroupNo === row.no) {
            flag = true;
            break;
          }
        }
        if (!flag) {
          this.employees.extPurchaseGroups.push({
            extPurchaseGroupName: row.name,
            extPurchaseGroupNo: row.no,
          });
        }else {
          this.$message.error("采购组:"+ row.name +"已存在,请勿重复添加！！！");
        }

      },
      oneDeletePurchaseGroup(index) {
        this.employees.extPurchaseGroups.splice(index, 1);
      },
      addMaterialGroup(row) {
        let flag = false;
        for (let item of this.employees.materialGroups) {
          if (item.materialGroupId === row.materialID) {
            flag = true;
            break;
          }
        }
        if (!flag) {
          this.employees.materialGroups.push({
            materialGroupId: row.materialID,
            materialName: row.materialName,
            materialNo: row.materialNO,
          });
        }else {
          this.$message.error("物料组:"+ row.materialName +"已存在,请勿重复添加！！！");
        }

      },
      oneDeleteMaterialGroup(index) {
        this.employees.materialGroups.splice(index, 1);
      },
      selectParentName(id) {
        this.employees.postID = id;
      },
      selectDepartment(row) {
        this.employees.departmentID = row.departmentID;
        this.employees.departmentName = row.departmentName;
      },
      selectDepartmentName(id) {
        this.employees.departmentID = id;
      },
      getData() {
        this.$http
          .get("basic", `employees/${this.employees.employeeID}`)
          .then(resp => {
            console.log(resp);
            this.employees = resp;
          });
      },
      getNode() {
        this.$http
          .get("basic", "employees/selectNo")
          .then(resp => {
            console.log(resp);
            this.employees.employeeNO = resp;
          });
      },
      submit() {
        if(this.employees.employeeID>0) {
          this.handleSubmitUpdData();
        }else{
          this.handleSubmitSave();
        }
      },
      handleSubmitUpdData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "employees", this.employees)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "employees", this.employees)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
